const baseStyle = {
  display: 'flex',
};
const defaultProps = {
  flexDirection: 'column',
  shadow: 0,
};

export default {
  baseStyle,
  defaultProps,
};
